export const normalizeInputDigits = (value: string): string => value.replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d))).replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));

/** Localized display only; normalizeInputDigits keeps API phone numbers ASCII. */
export const displayInputDigits = (value: string, language: string): string =>
  language.split('-')[0] === 'fa'
    ? value.replace(/[0-9]/g, digit => '۰۱۲۳۴۵۶۷۸۹'[Number(digit)])
    : value;
